"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toyota = exports.lexus = void 0;
var _styledComponents = require("styled-components");
var _index = _interopRequireDefault(require("./index.styled"));
const lexus = exports.lexus = (0, _styledComponents.createGlobalStyle)`
  .lexus-theme.tippy-tooltip.background-black {
    background: #fff;
    color: #000;
  }
  .lexus-theme.tippy-tooltip.background-white {
    background: #000;
    color: #fff;
  }
  .lexus-theme.tippy-tooltip {
    background: #000;
    color: #fff;
    padding: 15px 35px 15px 15px;
    text-align: left;
    border-radius: 0;
  }
  .lexus-theme.tippy-tooltip[data-placement^='right'] {
    transform: translate3d(5px, 0px, 0px);
  }
  .lexus-theme.tippy-tooltip[data-placement^='left'] {
    transform: translate3d(-5px, 0px, 0px)
  }

  .lexus-theme.tippy-tooltip.background-black[data-placement^='top'] > .tippy-arrow {
    border-top-color: #fff;
    border-width: 8px 10px 0 10px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='top'] > .tippy-arrow {
    border-top-color: #000;
    border-width: 8px 10px 0 10px;
  }

  .lexus-theme.tippy-tooltip.background-black[data-placement^='bottom'] > .tippy-arrow {
    border-bottom-color: #fff;
    border-width: 0 10px 8px 10px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='bottom'] > .tippy-arrow {
    border-bottom-color: #000;
    border-width: 0 10px 8px 10px;
  }

  .lexus-theme.tippy-tooltip.background-black[data-placement^='left'] > .tippy-arrow {
    border-left-color: #fff;
    border-width: 10px 0 10px 8px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='left'] > .tippy-arrow {
    border-left-color: #000;
    border-width: 10px 0 10px 8px;
  }

  .lexus-theme.tippy-tooltip.background-black[data-placement^='right'] > .tippy-arrow {
    border-right-color: #fff;
    border-width: 10px 8px 10px 0;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='right'] > .tippy-arrow {
    border-right-color: #000;
    border-width: 10px 8px 10px 0;
  }

  .lexus-theme.tippy-tooltip .tippy-content {
    overflow: auto;
    max-height: 175px;
    max-width: 200px;
    padding: 0 9px;
  }
  .lexus-theme.tippy-tooltip .tippy-content p {
    margin-top: 0;
  }
  .lexus-theme.tippy-tooltip .tippy-content p:last-child {
    margin-bottom: 0;
  }
  .lexus-theme.tippy-tooltip.background-white .tippy-content button svg {
    fill: #fff;
  }
  .lexus-theme.tippy-tooltip.background-black .tippy-content button svg {
    fill: #000;
  }
`;
const toyota = exports.toyota = (0, _styledComponents.createGlobalStyle)`
  .toyota-theme.tippy-tooltip {
    position: fixed!important;
    max-width: 100vw!important;
    width: 100vw!important;
    left: 50vw!important;
    top: 100vh!important;
    transform: translate3d(-50%, -100%, 0)!important;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.8);
    height: 117px;
    overflow: hidden;
    @media only screen and (min-width: 600px)  {
      width: 100vw!important;
      height: 70px;
    }
    @media only screen and (min-width: 768px)  {
      width: 730px!important;
      height: 90px;
    }
    @media only screen and (min-width: 1024px)  {
      width: 900px!important;
      height: 90px;
    }
    @supports (-webkit-touch-callout: none) {
      top: auto!important;
      bottom: 0!important;
      position: absolute!important;
      transform: translate3d(-50%, 0, 0)!important;
    }
  }

  .toyota-theme .tippy-arrow {
    display: none;
  }

  .toyota-theme .tippy-content {
    padding: 0;
    font-family: "ToyotaType";
    box-sizing: border-box;
  }

  .toyota-theme.tippy-popper {
    transform: none!important;
    @supports (-webkit-touch-callout: none) {
      height: 100%;
    }
  }

  ${_index.default.Disclaimer} {
   &:hover{
    &::after {
      position: absolute;
      content: "";
      bottom: 3px;
      width: 100%;
      height: 1px;
      background: black;
      left: 0;
    }
   }
  }
  ${_index.default.DisclaimerScroll} {
    overflow-y: scroll;
    display: block;
    max-height: 102px;
    margin-right: 5px;
    margin-top: 15px;
    scrollbar-width: auto;
    scrollbar-color: #666;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #666;
      border-radius: 6px;
    }
    @media only screen and (min-width: 600px)  {
      max-height: 55px;
    }
    @media only screen and (min-width: 768px)  {
      max-height: 75px;
    }
    @media only screen and (min-width: 1024px)  {
      max-height: 75px;
    }
  }
  ${_index.default.GradientDisclaimerBodyUp} {
    position: absolute;
    top: 0px;
    left: 0px;
    background-image: linear-gradient(0deg, rgba(255,255,255,0) 0px, rgb(0, 0, 0));
    width: 100%;
    height: 37px;
    z-index: 2;
    transform: translate3d(0, 0, 200px);
    pointer-events: none;
  }
  ${_index.default.GradientDisclaimerBodyDown} {
    position: absolute;
    bottom: 0px;
    left: 0px;
    background-image: linear-gradient(rgba(255,255,255,0) 0px, rgb(0, 0, 0));
    width: 100%;
    height: 37px;
    z-index: 2;
    transform: translate3d(0, 0, 200px);
    pointer-events: none;
  }
  ${_index.default.DisclaimerBodyContent} {
    margin: 0 0 15px 15px;
    padding-right: 55px;
    font-size: 10px!important;
    line-height: 14px!important;
    font-family: "ToyotaType", "ToyotaTypeReact"!important;
    letter-spacing: normal;
    z-index: 1;
    @media only screen and (min-width: 768px)  {
      padding-right: 65px;
    }
    a {
      text-decoration: underline;
    }
  }
  ${_index.default.DisclaimerBody} {
    min-height: 102px;
    @media only screen and (min-width: 600px)  {
      min-height: 55px;
    }
    @media only screen and (min-width: 768px)  {
      min-height: 75px;
    }
    @media only screen and (min-width: 1024px)  {
      min-height: 75px;
    }
    &:focus-visible {
      outline: revert;
    }
    div{
      font-family: "ToyotaType", "ToyotaTypeReact";
      p{
        margin: 0px;
        padding-bottom: 20px;
      }
    }
  }
  ${_index.default.CloseButton} {
    position: absolute;
    right: 20px;
    top: 15px;
    z-index: 3;
    transform: translate3d(0, 0, 300px);
    width: 40px;
    height: 40px;
    border: solid 2px #767676;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    transition: all .4s ease,top 0s,bottom 0s,left 0s,right 0s;
    svg {
      stroke: #FFF;
      stroke-width: 4px;
      transform: scale(0.3);
      min-width: 36px;
    }
    &:hover, :focus-visible {
      border-color: #FFF;
    }
  }
`;